// extracted by mini-css-extract-plugin
export default {"dot":"LRlzxO","line":"iiXWDa","lineAndDot":"C5ygaL","flip":"EuEwZI"};